import React, { createContext, useContext, useEffect, useState } from "react";
import { MetaMaskSDK } from "@metamask/sdk";

interface MessageNode {
	currentAccount: string | null;
	setCurrentAccount: Function;
	connectWallet: Function;
	checkWalletConnection: Function;
}
const WalletContext = createContext({} as MessageNode);

interface Props {}
export const WalletProvider: React.FC<Props> = ({ children }) => {
	const [currentAccount, setCurrentAccount] = useState("");

	const MMSDK = new MetaMaskSDK({
		dappMetadata: {
			name: "Wallet Gate",
			url: window.location.href,
		},
		headless: true,
		useDeeplink: true,
		enableAnalytics: false,
	});

	const connectWallet = async () => {
		const ethereum = MMSDK.getProvider();
		try {
			if (ethereum) {
				const accounts = await MMSDK.connect();
				const account = accounts[0];
				setCurrentAccount(account);
				console.log("Connected", account);
			} else alert("Get Metamask Extensions to connect your wallet !");
		} catch (e) {
			console.error(e);
		}
	};

	const checkWalletConnection = () => {
		const ethereum = MMSDK.getProvider();

		if (ethereum) {
			console.log("Wallet connected");
			ethereum.request({ method: "eth_accounts" }).then((accounts: any) => {
				if (accounts.length > 0) {
					const account = accounts[0]; //user could have multiple accounts in their wallet we just grab the first one.
					setCurrentAccount(account);
					console.log("We have an athourized account: ", account);
				} else {
					console.log("No authorized account found");
				}
			});
		} else {
			alert("Please use MetaMask to use this app");
		}
	};

	useEffect(checkWalletConnection, []);

	return (
		<WalletContext.Provider
			value={{
				currentAccount,
				setCurrentAccount,
				connectWallet,
				checkWalletConnection,
			}}
		>
			{children}
		</WalletContext.Provider>
	);
};

export const useAccount = () => useContext(WalletContext);
